module.exports = __webpack_public_path__ + "static/media/page_qyz_btn.5e822975.png";